module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "journal_content"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('p', {
    staticStyle: {
      "border-left": "3px solid #bbb",
      "padding-left": "10px",
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.showName(_vm.type)))]), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.showPage.fileName))])]), _vm._v(" "), _vm._l((_vm.journals), function(journal, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('a', {
      attrs: {
        "href": journal.fileUrl,
        "download": ""
      }
    }, [_c('div', [_vm._v(_vm._s(journal.title))])])])])
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9167819c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/JournalContent.vue
// module id = 1275
// module chunks = 4